export default "/fonts/iu.woff?0fa895f344377372dc0ea3906db8fa9f";